import { buttonClasses, styled } from "@mui/material";
import Mui5 from "components/mui5";

export const SortButton = styled(Mui5.Button)((props) => ({
  minWidth: 0,
  lineHeight: 0,
  fontSize: "inherit",

  [`&.${buttonClasses.root}`]: {
    textTransform: "none",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  [`&:hover .${buttonClasses.endIcon}`]: {
    opacity: 1,
  },
  [`& .${buttonClasses.startIcon}`]: {
    marginRight: props.theme.spacing(0.5),
  },
  [`& .${buttonClasses.endIcon}`]: {
    opacity: 0,
    marginLeft: props.theme.spacing(0.5),
  },
  "&[data-active='true']": {
    [`& .${buttonClasses.endIcon}`]: {
      opacity: 1,
    },
  },
}));
